<template>
  <v-container>
    <v-layout row wrap justify-center>
      <v-flex xs12 sm10 md8 lg7>
        <v-card>
          <v-container v-if="user.isCurrentUser">
            <h3 class="display-2">Your profile</h3>
          </v-container>
          <v-divider></v-divider>
          <v-layout row wrap>
            <v-flex class="user-graphic-container">
              <v-container fill-height>
                <v-layout align-center justify-center>
                  <v-flex class="user-graphic" v-on:click="clickedProfilePic()">
                    <v-container fill-height class="pa-0">
                      <v-layout align-center justify-center>
                        <NoProfilePicSvg class="no-image" v-if="!user.profile_url"/>
                        <v-img class="profile-pic fill-height" v-if="user.profile_url" :src="`${user.profile_url}`"/>
                        <div v-if="user.isCurrentUser">
                          <div class="user-graphic-hover">
                            <AddProfilePicSvg class="addProfilePicSvg"/>
                          </div>
                          <input ref="fileInput" type="file" v-on:change="handleFileChange"/>
                        </div>
                        <div v-if="uploading">
                          <div class="uploading-alert">
                            <v-container fill-height>
                              <v-layout align-center justify-center>
                                <div>
                                  <div class="body-1">Uploading..</div>
                                  <div class="body-1">{{percentageCompleted}}%</div>
                                </div>
                              </v-layout>
                            </v-container>
                          </div>
                        </div>
                      </v-layout>
                    </v-container>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
            <v-flex class="pt-4 pl-2 pr-2 pb-3" :class="{'ml-3': $vuetify.breakpoint.xs}">
              <div class="profile-name">{{user.first_name}} {{user.last_name}}</div>
            </v-flex>
          </v-layout>
          <v-divider v-if="user.isCurrentUser"></v-divider>
          <v-card-actions v-if="user.isCurrentUser" class="pa3">
            <v-layout row wrap>
              <v-flex>
                <v-btn v-if="user.profile_url" text color="error" @click="removeAvatar()">Remove avatar</v-btn>
                <v-btn text @click="clickedProfilePic()">Upload new avatar</v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
        <v-card class="mt-4" v-if="user.isCurrentUser">
          <v-container>
            <p class="display-1">Edit your personal settings</p>
          </v-container>
          <v-divider></v-divider>
          <v-form class="pt-4 pb-5 pl-4 pr-4" ref="userForm">
            <v-text-field type="text" label="First name" v-model="user.first_name" :rules=[rules.required]></v-text-field>
            <v-text-field type="text" label="Last name" v-model="user.last_name" :rules=[rules.required]></v-text-field>
            <v-text-field type="email" label="Email" v-model="user.email" autocomplete="false" autocapitalize="false" :rules=[rules.required]></v-text-field>
            <v-text-field type="email" label="Confirm email" hint="Please note that if you change your email address here, 
              you will need to use that new email address the next time you sign in." v-model="confirmEmail" 
              autocomplete="false" autocapitalize="false"></v-text-field>
          </v-form>
          <v-divider></v-divider>
          <v-container>
            <p class="display-1">Change your password</p>
          </v-container>
          <v-divider></v-divider>
          <v-form class="pt-4 pb-5 pl-4 pr-4" ref="passwordForm">
            <v-text-field type="password" label="Current password" v-model="password"></v-text-field>
            <v-text-field type="password" label="New password" hint="Password must be at least 8 characters long and contain a mixture of upper 
              case letters, lower case letters, numbers and symbols." v-model="newPassword" :validate-on-blur=true 
              :rules=[rules.passwordValidityAllowEmpty]></v-text-field>
            <v-text-field type="password" label="Confirm password" v-model="confirmPassword"></v-text-field>
          </v-form>
          <v-divider></v-divider>

          <v-divider></v-divider>
          <div class="profile-section pt-2 pb-2 pr-2">
            <v-layout justify-end>
              <v-btn dark color="#e7511e" v-on:click="updateClicked()">Update Profile</v-btn>
            </v-layout>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import NoProfilePicSvg from 'assets/svg/user.svg';
import AddProfilePicSvg from 'assets/svg/user-add.svg';
import CommonRules from 'src/common-rules.js';
import UsersApi from '@/services/UsersApi';
export default {
  components: {
    NoProfilePicSvg,
    AddProfilePicSvg
  },
  async mounted(){
    try {
      const response = await UsersApi.getProfile({
        params: {
          public_id: this.$route.query.user
        }
      })
      this.user = response.data.user;
    } catch(err) {
      // eslint-disable-next-line
      console.log(err)
    }
  },
  created: () => {
    document.title = 'ThinkSpatial | Profile';
  },
  data() {
    let data = {
      user: {
        profile_url: null,
        firstName: null,
        lastName: null,
        email: null,
        isCurrentUser: true
      },
      password: null,
      newPassword: null,
      confirmPassword: null,
      confirmEmail: null,
      uploading: false,
      percentageCompleted: 0,
      rules: CommonRules
    };
    return data;
  },
  methods: {
    clickedProfilePic: function() {
      if (!this.user.isCurrentUser) {
        return;
      }
      this.$refs.fileInput.click();
    },
    async handleFileChange () {
      try {    
        if (this.$refs.fileInput.files.length === 0) {
          return;
        }
        this.percentageCompleted = 0;
        this.uploading = true;
        let formData = new FormData();
        formData.append('file', this.$refs.fileInput.files[0]);
        let axiosConfig = {
          onUploadProgress: progressEvent => {
            this.percentageCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
          },
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
        const response = await UsersApi.setAvatar(formData, axiosConfig )
        if(response.data.error){
          this.$swal({
            title: 'Oops!',
            text: response.data.message.message,
            type: 'error'
          }).then(()=>{
            this.uploading = false;
          });
        } else {
          this.uploading = false;
          this.user.profile_url = response.data.user.profile_url;
          this.$store.dispatch('setUser', response.data.user);
        }
      } catch(err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async removeAvatar() {
      try {
        const response = await UsersApi.removeAvatar();
        if(response.data.error){
          this.$swal({
            title: 'Oops!',
            text: response.data.message,
            type: 'error'
          });
        } else {
          this.user.profile_url =response.data.user.profile_url;
          this.$store.dispatch('setUser', response.data.user);
        }
      } catch(err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async updateClicked() {
      if (!this.$refs.userForm.validate() || 
        !this.$refs.passwordForm.validate() || 
        !this.$refs.passwordForm.validate()) {
          return;
        }

      let changingEmail = this.user.email !== this.$store.state.user.email;
      if (changingEmail && this.confirmEmail !== this.user.email) {
        this.$swal({
          title: 'Oops!',
          text: 'Your email confirmation did not match your new email address.',
          type: 'error'
        });
        return;
      }

      if (this.newPassword || this.confirmPassword) {
        if (!this.password) {
          this.$swal({
            title: 'Oops!',
            text: 'You must enter your current password to be able to change your password.',
            type: 'error'
          });
          return;
        }

        if (this.newPassword !== this.confirmPassword) {
          this.$swal({
            title: 'Oops!',
            text: 'Your password confirmation did not match your new password.',
            type: 'error'
          });
          return;
        }
      }

      let data = {
        firstName: this.user.first_name,
        lastName: this.user.last_name,
      };

      if (changingEmail) {
        data.email = this.user.email;
      }

      if (this.newPassword) {
        data.currentPassword = this.password;
        data.newPassword = this.newPassword;
      }
      const response = await UsersApi.setProfile(data)
      if (response.data.error) {
        this.$swal({
          title: 'Oops!',
          text: response.data.message,
          type: 'error'
        });
      } else {
        this.$store.dispatch('setToken', response.data.token)
        this.$store.dispatch('setUser', response.data.user)
        this.$swal({
          title: 'Success!',
          text: 'Your profile has been updated.',
          type: 'success'
        });
        this.password = null;
        this.confirmPassword = null;
        this.newPassword = null;
        this.confirmEmail = null;        
      }  
    },
  }
}
</script>
<style lang="scss" scoped>
@import 'assets/landing.scss';

.v-card__actions .v-btn + .v-btn {
  margin-left: 0;
}

.v-card__actions .v-btn {
  margin-right: 8px;
}

.subheading-1 {
  margin-bottom: 0;
}

.profile-section{
  margin-bottom: 66px;
}

.profile-pic {
  border-radius: 360px;
}

.profile-name {
  font-size: 24px;
  margin: 4px 0;
  font-family:'Nova Flat', 'Open Sans', Helvetica, Arial, sans-serif !important;
}
.profile-company,
.profile-company-title {
  font-size: 14px;
  color: $text-secondary;
}

.profile-member-since {
  font-size: 14px;
  margin: 5px 0;
  font-style: italic;
}

.user-graphic {
  max-width: 128px;
  max-height: 128px;
  width: 128px;
  height: 128px;
  position: relative;
  background-color: #ddd;
  border-radius: 90px;
  text-align: center;
}

.user-graphic input[type="file"] {
  display: none;
}

.user-graphic-container {
  width: 168px;
  height: 168px;
  max-width: 168px;
  max-height: 168px;
}

.user-graphic .user-graphic-hover, .user-graphic .uploading-alert {
  position: absolute;
  left: 0;
  top: 0;
  display: none;
  width: 128px;
  height: 128px;
  border-radius: 90px;
  border: 4px dashed #4A4A4A;
  text-align: center;
  z-index: 3;
}

.user-graphic .uploading-alert {
  display: block;
  z-index: 4;
  border: none;
  background: rgba(0,0,0,0.4);
}

.uploading-alert {
  color: #fff;
  text-align: center;
}

.user-graphic:hover .user-graphic-hover svg {
  width: 72px;
  height: 72px;
  margin-top: 20px;
}

.user-graphic:hover .user-graphic-hover {
  display: block;
  cursor: pointer!important;
  background-color: #ddd;
}

.user-graphic svg.no-image {
  width: 96px;
  height: 96px;
  z-index: 1;
}

.no-image .st0 {
  fill: #fff;
  stroke:#FFFFFF;stroke-miterlimit:10;
}

.addProfilePicSvg .st0 {
  fill: #fff;
  stroke:#FFFFFF;stroke-miterlimit:10;
}

.addProfilePicSvg .st1 {
  fill:none;
  stroke:#4B4B4B;
  stroke-width:11;
  stroke-miterlimit:10;
}

.upload-spinner {
  position: absolute;
  top: -2px;
  left: -2px;
}

</style>
